import { app } from 'infra/configs/app';
import { browserStorage } from 'infra/services/browser-storage/browserStorage';

export const isApiSwitchEnabled = app.dev || app.staging;

export const getApiOverride = (): string | null => {
	if (!isApiSwitchEnabled) return null;
	return browserStorage.get('apiOverride');
};

export const setApiOverride = (url: string): void => {
	if (!isApiSwitchEnabled) return;
	browserStorage.set('apiOverride', url);
};

export const clearApiOverride = (): void => {
	browserStorage.remove('apiOverride');
};
